var _defs, _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAboutPartnersBgElement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 352 382",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F4F4",
    d: "M46.21 330.12l-.766-.642 206.335-245.9.766.642zM93.203 291.23l-.766-.644L298.13 45.452l.766.643z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 233.851,
    cy: 122.056,
    r: 69.5,
    transform: "rotate(-140 233.851 122.056)",
    stroke: "#7CA1A1"
  })));
}

var MemoSvgAboutPartnersBgElement = /*#__PURE__*/React.memo(SvgAboutPartnersBgElement);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUyIiBoZWlnaHQ9IjM4MiIgdmlld0JveD0iMCAwIDM1MiAzODIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjQ2LjIwOTUiIHk9IjMzMC4xMiIgd2lkdGg9IjEiIGhlaWdodD0iMzIxIiB0cmFuc2Zvcm09InJvdGF0ZSgtMTQwIDQ2LjIwOTUgMzMwLjEyKSIgZmlsbD0iI0Y2RjRGNCIvPgo8cmVjdCB4PSI5My4yMDMxIiB5PSIyOTEuMjI5IiB3aWR0aD0iMSIgaGVpZ2h0PSIzMjAiIHRyYW5zZm9ybT0icm90YXRlKC0xNDAgOTMuMjAzMSAyOTEuMjI5KSIgZmlsbD0iI0Y2RjRGNCIvPgo8Y2lyY2xlIGN4PSIyMzMuODUxIiBjeT0iMTIyLjA1NiIgcj0iNjkuNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE0MCAyMzMuODUxIDEyMi4wNTYpIiBzdHJva2U9IiM3Q0ExQTEiLz4KPC9zdmc+Cg==";
export { MemoSvgAboutPartnersBgElement as ReactComponent };